// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ItalicOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 384 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M128 56c0-13.3 10.7-24 24-24h208c13.3 0 24 10.7 24 24s-10.7 24-24 24h-68.7L144.7 432H232c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h68.7L239.3 80H152c-13.3 0-24-10.7-24-24z"}}]},"name":"italic","theme":"outlined"};

const ItalicOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ItalicOutlinedSvg} />;
  ItalicOutlined.displayName = 'ItalicOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ItalicOutlined);
